// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-IrB","buttons":"Footer_buttons__2W1HT"};